var app = angular.module('leonardo');

var ReportsMimoList = function ($scope, $controller, $filter, ReportService, AttachmentService, ReportFilterService) {
  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Move In / Move Out Reports');
  $scope.report_type = ReportService.TYPE_MIMO;

  $scope.fieldsReport = ReportService.fieldsReportMimo;
  $scope.fieldInvalidTypes = ReportFilterService.fieldInvalidTypes;

  $scope.getFieldClasses = function (report, field) {
    var classes = [];
    if (_.contains(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput', 'fileEmbedded'], field.component)) {
      classes.push('inspection-data-media');
    }
    if (!isNull(report.move_in_inspection_result) && !isNull(report.move_in_inspection_result.data) &&
      !isNull(report.move_in_inspection_result.data[field.id])) {
      if (!isEmpty(report.move_in_inspection_result.data[field.id].photo) && !classes.includes('inspection-data-media')) {
        classes.push('inspection-data-media');
      }
    }
    if (!isNull(report.move_out_inspection_result) && !isNull(report.move_out_inspection_result.data) &&
      !isNull(report.move_out_inspection_result.data[field.id])) {
      if (!isEmpty(report.move_out_inspection_result.data[field.id].photo) && !classes.includes('inspection-data-media')) {
        classes.push('inspection-data-media');
      }
    }
    return classes;
  };

  $scope.getHeightValue = function (report, field) {
    var height = $scope.getFieldClasses(report, field).includes('inspection-data-media') ? 70 : 20;
    var inHeight = 0;
    var outHeight = 0;
    var isFileInput = ['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput', 'fileEmbedded'].includes(field.component);

    if (!isNull(report.move_in_inspection_result) && !isNull(report.move_in_inspection_result.data) &&
      !isNull(report.move_in_inspection_result.data[field.id])) {
      var inFileElements = 0;
      if (isFileInput && !isEmpty(report.move_in_inspection_result.data[field.id].value)) {
        var valueIn = report.move_in_inspection_result.data[field.id].value;
        var valueInElements = angular.isArray(valueIn) ? valueIn.length : 1;
        inFileElements = valueInElements > inFileElements ? valueInElements : inFileElements;
      }
      var inFileHeight = inFileElements * 70;
      var inAttachmentElements = 0;
      if (!isEmpty(report.move_in_inspection_result.data[field.id].notes)) {
        inAttachmentElements++;
      }
      if (!isEmpty(report.move_in_inspection_result.data[field.id].photo)) {
        angular.forEach(report.move_in_inspection_result.data[field.id].photo, function (photo){
          if (!isNull(photo.comment)) {
            inAttachmentElements++;
          }
          inAttachmentElements++;
        });
      }
      var inAttachmentHeight = inAttachmentElements * 40;
      inHeight = inAttachmentHeight > inFileHeight ? inAttachmentHeight : inFileHeight;
    }
    if (!isNull(report.move_out_inspection_result) && !isNull(report.move_out_inspection_result.data) &&
      !isNull(report.move_out_inspection_result.data[field.id])) {
      var outFileElements = 0;
      if (isFileInput && !isEmpty(report.move_out_inspection_result.data[field.id].value)) {
        var valueOut = report.move_out_inspection_result.data[field.id].value;
        var valueOutElements = angular.isArray(valueOut) ? valueOut.length : 1;
        outFileElements = valueOutElements > outFileElements ? valueOutElements : outFileElements;
      }
      var outFileHeight = outFileElements * 70;
      var outAttachmentElements = 0;
      if (!isEmpty(report.move_out_inspection_result.data[field.id].notes)) {
        outAttachmentElements++;
      }
      if (!isEmpty(report.move_out_inspection_result.data[field.id].photo)) {
        angular.forEach(report.move_out_inspection_result.data[field.id].photo, function (photo){
          if (!isNull(photo.comment)) {
            outAttachmentElements++;
          }
          outAttachmentElements++;
        });
      }
      var outAttachmentHeight = outAttachmentElements * 40;
      outHeight = outAttachmentHeight > outFileHeight ? outAttachmentHeight : outFileHeight;
    }
    var heightElements = outHeight > inHeight ? outHeight : inHeight;
    var result = heightElements > height ? heightElements : height;
    return result + 'px' ;
  };

  $scope.getExtraAttributes = function (report, data, field) {
    var classes = $scope.getFieldClasses(report, field).join(' ');
    var html = '<span class="inspection-data inspection-data-comments ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, field) + '">';
    if (data.notes) {
      var noteText = (typeof data.notes === 'object' && data.notes !== null && data.notes.content !== undefined) ? data.notes.content : (typeof data.notes === 'object' ? JSON.stringify(data.notes) : data.notes);
      html += '<span><p class="italic">' + noteText + '</p></span>';
    }
    if (data.photo) {
      if (angular.isArray(data.photo)) {
        angular.forEach(data.photo, function(photo) {
          var href = photo.link ? photo.link : photo.file;
          if (!isNull(href)) {
            if (AttachmentService.getClassesAttachment(photo) === 'image') {
              html += '<span><img src="' + href + '" name="' + photo.name + '"/></span>';
            }
            else {
              html += '<span><a href="' + href + '" target="_blank">' + photo.name + '</a></span>';
            }
          }
          if (photo.comment) {
            html += '<span><p class="italic">' + photo.comment + '</p></span>';
          }
        });
      }
      else {
        var href_link = data.photo.link ? data.photo.link : data.photo.file;
        if (!isNull(href_link)) {
          if (AttachmentService.getClassesAttachment(data.photo) === 'image') {
            html += '<span><img src="' + href_link + '" name="' + data.photo.name + '"/></span>';
          }
          else {
            html += '<span><a href="' + href_link + '" target="_blank">' + data.photo.name + '</a></span>';
          }
        }
        if (data.photo.comment) {
          html += '<span><p class="italic">' + data.photo.comment + '</p></span>';
        }
      }
    }
    return html + '</span>';
  };

  $scope.getReportFieldValue = function (report, data, field) {
    var classes = $scope.getFieldClasses(report, field).join(' ');
    var html = '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, field) + '">';
    if (isNull(data) || !_.contains(Object.keys(data), 'value') || isNull(data.value)) {
      return html + '</span>';
    }
    var index = null;
    var value = '';
    if (_.contains(['checkbox', 'checkboxJustifiedLeft'], field.component)) {
      if (angular.isArray(data.value)) {
        if (field.show_unselected_checkbox) {
          angular.forEach(field.options, function (element, key) {
            value = element.value ? element.value : element;
            if ($scope.containsValue(data.value, key)) {
              html += '<span>' + value + '<icon class="icon" icon-image="icon-check.svg" icon-width="15" icon-height="15" icon-color="secondaryColor"></icon></span>';
            }
            else {
              html += '<span>' + value + '</span>';
            }
          });
        }
        else {
          html += uniqueMimoMethod(data);
        }
      }
      else {
        if (field.show_unselected_checkbox) {
          angular.forEach(field.options, function (element, key) {
            value = element.value ? element.value : element;
            if (data.value.toString() === key.toString()) {
              html += '<span>' + value + '<icon class="icon" icon-image="icon-check.svg" icon-width="15" icon-height="15" icon-color="secondaryColor"></icon></span>';
            }
            else {
              html += '<span>' + value + '</span>';
            }
          });
        }
        else {
          index = isNaN(data.value) ? data.value : parseInt(data.value);
          if (field.options[index]) {
            value = field.options[index].value ? field.options[index].value : field.options[index];
            html += '<span>' + value + '</span>';
          }
        }
      }
    }
    else if (_.contains(['select', 'radio', 'radioJustifiedLeft', 'ratingScale3pt'], field.component)) {
      if (angular.isArray(data.value)) {
        html += uniqueMimoMethod(data);
      }
      else {
        index = isNaN(data.value) ? data.value : parseInt(data.value);
        if (field.options[index]) {
          value = field.options[index].value ? field.options[index].value : field.options[index];
          html += '<span>' + value + '</span>';
        }
      }
    }
    else if (_.contains(['dateInput'], field.component)) {
      html += moment(data.value).format('MM/DD/YYYY');
    }
    else if (_.contains(['dateTimeInput'], field.component)) {
      html += moment(data.value).format('MM/DD/YYYY H:mm:ss');
    }
    else if (_.contains(['timeInput'], field.component)) {
      var hour = new Date();
      hour.setHours(data.value.split(':')[0]);
      hour.setMinutes(data.value.split(':')[1]);
      html += moment(hour).format('H:mm');
    }
    else if (_.contains(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput'], field.component)) {
      if (angular.isArray(data.value)) {
        angular.forEach(data.value, function (element) {
          var href_url;
          if (element.link) {
            href_url = element.link;
          }
          else {
            href_url = (element.thumbnail ? element.thumbnail : element.file);
          }
          if (!isNull(href_url)) {
            if (AttachmentService.getClassesAttachment(element) === 'image') {
              html += '<span><img src="' + href_url + '" id="' + element.name + '"/></span>';
            }
            else {
              html += '<span><a href="' + href_url + '" target="_blank">' + element.name + '</a></span>';
            }
          }
        });
      } else {
        var href_link;
        if (data.value.link) {
          href_link = data.value.link;
        }
        else {
          href_link = (data.value.thumbnail ? data.value.thumbnail : data.value.file);
        }
        if (!isNull(href_link)) {
          if (AttachmentService.getClassesAttachment(data.value) === 'image') {
            html += '<span><img src="' + href_link + '" id="' + data.value.name + '"/>';
          }
          else {
            html += '<span><a href="' + href_link + '" target="_blank">' + data.value.name + '</a><span>';
          }
        }
      }
    }
    else if (_.contains(['fileEmbedded'], field.component)) {
      if (!isNull(field.embedded) && (field.embedded.length > 0)) {
        var href;
        if (field.embedded[0].link) {
          href = field.embedded[0].link;
        }
        else {
          href = (field.embedded[0].thumbnail ? field.embedded[0].thumbnail : field.embedded[0].file);
        }
        if (AttachmentService.getClassesAttachment(field.embedded[0]) === 'image') {
          html += '<span><img src="' + href + '" id="' + field.embedded[0].name + '"/><span>';
        }
        else {
          html += '<span><a href="' + href + '" target="_blank">' + field.embedded[0].name + '</a><span>';
        }
      }
    }
    else if (_.contains(['currencyInput'], field.component)) {
      html += $filter('currency')(data.value, '$', 2);
    }
    else {
      html  += data.value;
    }

    return html + '</span>';
  };

  function uniqueMimoMethod(data, index, field, value, html){
    angular.forEach(data.value, function (element) {
      index = isNaN(element) ? element : parseInt(element);
      if (field.options[index]) {
        value = field.options[index].value ? field.options[index].value : field.options[index];
        html += '<span>' + value + '</span>';
      }
    });
    return html;
  }

  $scope.existInspectionData = function (report, field_id) {
    return (!isNull(report['move_in_inspection_result']) && !isNull(report['move_in_inspection_result'].data) && !isNull(report['move_in_inspection_result'].data[field_id])) ||
      (!isNull(report['move_out_inspection_result']) && !isNull(report['move_out_inspection_result'].data) && !isNull(report['move_out_inspection_result'].data[field_id]));
  };

  $scope.getFieldValue = function (report, field) {
    var html = '';
    switch (field) {
      case 'account':
      case 'portfolio':
      case 'action_item':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'pms_external_id':
        return (report.property && report.property[field]) ? report.property[field] : report[field];
      case 'section':
        var section_inspection = report.move_in_inspection_result || report.move_out_inspection_result;
        html = '';
        if (section_inspection && section_inspection.dynamic_form_fields) {
          angular.forEach(section_inspection.dynamic_form_fields, function (section) {
            angular.forEach(section.children, function (child) {
              if (!$scope.fieldInvalidTypes.includes(child.component) && $scope.existInspectionData(report, child.id)) {
                var classes = $scope.getFieldClasses(report, child).join(' ');
                html += '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, child) + '">' + section.label + '</span>';
              }
            });
          });
        }
        return html;
      case 'inspection_item':
        var inspection = report.move_in_inspection_result || report.move_out_inspection_result;
        html = '';
        if (inspection && inspection.dynamic_form_fields) {
          angular.forEach(inspection.dynamic_form_fields, function (section) {
            angular.forEach(section.children, function (child) {
              if (!$scope.fieldInvalidTypes.includes(child.component) && $scope.existInspectionData(report, child.id)) {
                var classes = $scope.getFieldClasses(report, child).join(' ');
                html += '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, child) + '">' + child.label + '</span>';
              }
            });
          });
        }
        return html;
      case 'move_in_inspection_result':
      case 'move_out_inspection_result':
        html = '';
        if (report[field] && report[field].dynamic_form_fields) {
          angular.forEach(report[field].dynamic_form_fields, function (section) {
            angular.forEach(section.children, function (child) {
              if (report[field].data && report[field].data[child.id]) {
                html += $scope.getReportFieldValue(report, report[field].data[child.id], child);
              }
              else if (!$scope.fieldInvalidTypes.includes(child.component) && $scope.existInspectionData(report, child.id)) {
                var classes = $scope.getFieldClasses(report, child).join(' ');
                html += '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, child) + '"></span>';
              }
            });
          });
        }
        return html;
      case 'move_in_inspection_comments':
        var move_in_inspection = report.move_in_inspection_result;
        html = '';
        if (move_in_inspection && move_in_inspection.dynamic_form_fields) {
          angular.forEach(move_in_inspection.dynamic_form_fields, function (section) {
            angular.forEach(section.children, function (child) {
              if (move_in_inspection.data && move_in_inspection.data[child.id]) {
                html += $scope.getExtraAttributes(report, move_in_inspection.data[child.id], child);
              }
              else if (!$scope.fieldInvalidTypes.includes(child.component) && $scope.existInspectionData(report, child.id)) {
                var classes = $scope.getFieldClasses(report, child).join(' ');
                html += '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, child) + '"></span>';
              }
            });
          });
        }
        return html;
      case 'move_out_inspection_comments':
        var move_out_inspection = report.move_out_inspection_result;
        html = '';
        if (move_out_inspection && move_out_inspection.dynamic_form_fields) {
          angular.forEach(move_out_inspection.dynamic_form_fields, function (section) {
            angular.forEach(section.children, function (child) {
              if (move_out_inspection.data && move_out_inspection.data[child.id]) {
                html += $scope.getExtraAttributes(report, move_out_inspection.data[child.id], child);
              }
              else if (!$scope.fieldInvalidTypes.includes(child.component) && $scope.existInspectionData(report, child.id)) {
                var classes = $scope.getFieldClasses(report, child).join(' ');
                html += '<span class="inspection-data ' + classes + '" ' +
                  'style="height:' + $scope.getHeightValue(report, child) + '"></span>';
              }
            });
          });
        }
        return html;
      case 'portfolios':
      case 'properties':
      case 'groups':
      case 'managed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (element) {
            html += '<span>' + element.name + '</span>';
          });
          return html;
        }
        else {
          if (report[field]) {
            html = report[field].name;
            return html;
          }
          html = (field === 'managed_by') ? 'Only Owner' : ''
          return html;
        }
      default:
        return report[field];
    }
  };
};

app.controller('ReportsMimoList', ['$scope', '$controller', '$filter', 'ReportService', 'AttachmentService',
  'ReportFilterService', ReportsMimoList]);
